//Authentication
export const Authentication = `auth`
export const AuthenticationLogin = `auth/login`

// ************************** Catalogs

// Catalogs main
export const catalogsMenu = `catalogs`

// Laboratory Segments
export const labSegments = `laboratory-segments`

// Lab types
export const labTypes = `laboratory-types`

// Lab areas
export const labAreas = `laboratory-areas`

//Coordinations
export const coordinations = `coordinations`

//Service Types
export const serviceTypes = `service-types`

//Locations
export const locations =`locations`

//Default Assignments
export const defaultAssignments = `default-assignments`

//Technical Advisers
export const technicalAdvisers = `technical-advisers`

//Unit measures
export const unitMeasures = `unit-measures`

//Kinds
export const kinds = `kinds`

//Customers
export const customers = `customers`

//Product types
export const productTypes = `product-types`

//Providers
export const providers = `providers`

//Status samples
export const statusSamples = `status-samples`

// Types regulations
export const typesRegulations = `types-regulations`

// Products
export const products = `products`

// Regions
export const regions = `regions`

// Dipi Regions
export const dipiRegions = `dipi-regions`

// Norms
export const norms = `norms`

// Ema regulations
export const emaRegulations = `ema-regulations`

// Internal regulations
export const internalSamples = `internal-samples`

// Lab Tests
export const labTests = `lab-tests`

// Lab Tests Samples
export const labTestSamples = `lab-tests-samples`

// Survey Categories
export const surveyCategories = `survey-categories`

// Survey Concepts
export const surveyConcepts = `survey-concepts`

// Laboratories
export const labs = `laboratories`

// Laboratories
export const quotations = `quotations`

// ************************** Lab Request Services
// Lab request
export const labRequests = `lab-requests`

// Lab request samples
export const labRequestSamples = `lab-request-samples`
// [Lab request samples POST Sample to Process]
export const labRequestSamplesToProcess = `samples-to-process`
// [Lab request samples PATCH Set Lab request Test]
export const labRequestSamplesSetTest = `set-lab-request-test`

// Lab request tests
export const labRequestTracking = `lab-request-trackings`

// Lab request tests
export const labRequestTests = `lab-request-tests`

// Lab request requirements
export const labRequestReqs = `lab-request-requirements`

//Lab request report
export const labRequestReport = `lab-request-reports`

//Lab request report auxiliars
export const labRequestReportAux = `lab-request-report-auxiliars`

//Lab request report auxiliars
export const labRequestAssignments = `lab-request-assignments`

//URL index for updating Record Status
export const updateStatus = `update-status`

//URL index for updating Record Status
export const generalStatus = `general-status`

//Lab Request Incidents
export const labRequestIncidents = `lab-request-incidents`

//Lab Request Delivery Result
export const labRequestDeliveryResult = `lab-request-delivery-results`

//Lab Request Delivery Result
export const labRequestDeliveryResultAux = `lab-request-delivery-result-auxiliar`

//Lab Request Calendared records
export const labRequestCalendaredRecord = `calendared-records`

//Lab Request Essays
export const labRequestEssay = `lab-request-essays`

//Lab Request Test Samples
export const labRequestTestSamples = `lab-request-test-samples`

//Lab request surveys
export const labRequestSurvey = `lab-request-survey`

//Lab request surveys responses
export const labRequestSurveyResponse = `lab-request-survey`

//Lab request quotes
export const labRequestQuotes = `lab-request-quotations`

//Lab request Roi & Reports
export const labRequestReportRoi = `lab-requests/report`

// ************************** Notifications
// Notification Managers
export const notificationManagers = `notification-managers`

// Notification Responsibles
export const notificationResponsibles = `notification-responsibles`


// ************************** Norms Library
export const normsLibrary = `norms-library`